import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./MainPage";
import LoginPage from "./LoginPage";

// Resolve API base dynamically:
// 1) Use env var if provided (recommended).
// 2) Else: if running on localhost (any port) -> http://localhost:5000
// 3) Else: same origin as the frontend (works when backend is on the same domain)
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : window.location.origin);

const App = () => {
  const [userEmail, setUserEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/current-user`, {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then((data) => {
        setUserEmail(data.google_email);
      })
      .catch(() => {
        setUserEmail(null);
      })
      .finally(() => setLoading(false));
  }, []); // run once on mount

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={userEmail ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route
          path="/"
          element={userEmail ? <MainPage userEmail={userEmail} /> : <Navigate to="/login" replace />}
        />
        <Route
          path="*"
          element={<Navigate to={userEmail ? "/" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
};

export default App;
